<!-- 城管 -->
<template>
    <MainLayout class="main-layout" rightWidth="320px" @toggleRight="handleToggleRight" :hasLeft="false">
        <News slot="header"> </News>
        <!-- 中间地图 -->
        <div ref="middlRef" slot="main" class="c-middle" style="padding: 12px">
            <el-row style="height: 100%;" :gutter="0" class="video-map-row">
                <div class="video-col" :class="{ collapsed: isVideoCollapsed }"
                    style="height: 100%; position: relative;">
                    <div class="video-panel-container">
                        <VideoGrid :videoList="videoList" :treeData="videoTreeData" :allCeseList="allCeseList"
                            :showTree="false" :showTitle="false" :treeProps="treeProps" @case-select="handleCaseSelect"
                            :activityId="activityCase.id">
                            <template v-slot:headerLeftExtraAfter>
                                <div class="video-grids__header-live" :class="{ activeVideo: isHistoryVideo }"
                                    @click="handleLiveVideoClick">{{ $t('home.middle.video.liveVideo') }}</div>
                                <div class="video-grids__header-history" :class="{ activeVideo: !isHistoryVideo }"
                                    @click="handleHistoryVideoClick">{{ $t('home.middle.video.historyVideo') }}</div>
                            </template>
                        </VideoGrid>
                    </div>
                </div>
                <div class="map-col" :class="{ expanded: isVideoCollapsed }" style="height: 100%; position: relative;">
                    <div class="video-collapse-toggle" @click="toggleVideoPanel">
                        <img class="arrow-img"
                            :src="require(`@/assets/images/bg/left-${isVideoCollapsed ? 'show' : 'hide'}.png`)" />
                    </div>
                    <MapContainer ref="mapRef" :useServiceConfigZoom="false" :zoom="12"
                        :bottomToolConfig="bottomToolConfig" @emergencyClick="handleEmergencyClick">
                        <template slot="openlayer">
                            <OpenlayerYingJiLayer :commandType="commandType" @bindCaseList="getCaseList"
                                :allCeseList="allCeseList" :activityCase="activityCase" :userList="userList"
                                :cameraList="cameraList" :caseCanvasList="caseCanvasList"
                                @update:dangerObj="handleDangerObjUpdate"
                                @resetEmergencyFlyType="handleResetEmergencyFlyType">
                            </OpenlayerYingJiLayer>
                            <!-- 全景点位 -->
                            <PanoramaPoint layerVisible :pointList="panoramalocationList"></PanoramaPoint>
                        </template>
                        <template slot="bottomtool">
                            <EmergencyTool v-model="commandType" @emergencyClick="handleEmergencyClick">
                            </EmergencyTool>
                            <ImBadge />
                        </template>
                    </MapContainer>
                    <div class="legend-position">
                        <Legend :hasEmergency="true" :hasGrid="false">
                        </Legend>
                    </div>
                </div>
            </el-row>

        </div>
        <!-- 右侧 -->
        <RightIndex ref="rightRef" slot="right" :rightShow="rightShow" :allCeseList="allCeseList"
            @selectCaseId="selectCaseId" :startDate="startDate" :endDate="endDate"
            @update:startDate="handleUpdateStartDate" @update:endDate="handleUpdateEndDate" />
    </MainLayout>
</template>

<script>
import Legend from '@/page/mainPage/components/LeGend.vue';
import MainLayout from '@/components/layout';
import News from '@/page/mainPage/components/news/News.vue';
import RightIndex from './components/RightIndex.vue';
import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import OpenlayerYingJiLayer from '../components/OpenlayerYingJiLayer.vue';
import PanoramaPoint from '@/page/mainPage/mapComponents/panorama-point.vue';
import EmergencyTool from '../components/EmergencyTool.vue';
import api from '@/page/business/yingji/api/index.js';
import apiPanorama from '@/api/dataManagement/panorama';
import VideoGrid from '@/components/VideoGrid';

export default {
    components: {
        MainLayout,
        News,
        RightIndex,
        MapContainer,
        OpenlayerYingJiLayer,
        PanoramaPoint,
        Legend,
        VideoGrid,
        EmergencyTool,
    },
    props: {},

    data () {
        return {
            rightShow: false,
            allCeseList: [],
            videoList: [], // 视频列表
            videoTreeData: [], // 视频树形数据
            treeProps: {
                value: 'id',
                label: 'label',
                children: 'children',
            },
            searchForm: {
                queryDate: [],
            },
            commandType: '',
            activityCase: {}, // 当前选中的应急案件
            caseCanvasList: [], // 应急案件的地图绘制信息列表
            aircraftList: [], // 无人机列表
            userList: [], // 应急班组列表
            cameraList: [], // 地面摄像头列表
            panoramalocationList: [], // 全景点列表
            uavMap: {}, // 无人机地图
            timerId: null, // 统一刷新定时器ID
            isHistoryVideo: true, // 是否显示实时视频
            isVideoCollapsed: true, // 是否折叠视频面板
            isFullScreen: false, // 是否全屏
            dangerObj: null, // 危险源对象
            startDate: null, // 开始日期
            endDate: null, // 结束日期
        };
    },
    created () {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        this.startDate = `${year}-${month}-${day} 00:00:00`;
        this.endDate = `${year}-${month}-${day} 23:59:59`;
    },
    watch: {
        allCeseList: {
            handler (newVal, oldVal) {
                if (newVal.length > 0) {
                    this.getCaseCanvasList(this.allCeseList);
                }
            },
            deep: true,
        },
        dangerObj: {
            handler (newVal) {
                if (newVal) {
                    this.stopTimer();
                } else {
                    this.startTimer();
                }
            },
            immediate: true,
        },
    },
    computed: {
        /**
         * 底部工具栏的配置
         *
         * @returns 返回底部工具栏的配置对象
         */
        bottomToolConfig () {
            return {
                showFly: false,
                showYingJi: true, // 是否显示应急飞行按钮
            };
        },
    },
    methods: {
        // 处理实时指挥按钮点击事件
        handleEmergencyClick (type) {
            // console.log('handleEmergencyClick', type);
            // 如果已经是同一个类型，先清空再重新赋值，强制触发watch更新，支持重复点击唤醒
            if (this.commandType === type) {
                this.commandType = '';
                this.$nextTick(() => {
                    this.commandType = type;
                });
            } else {
                this.commandType = type;
            }
        },

        // 处理重置底部工具栏应急高亮状态
        handleResetEmergencyFlyType () {
            // 清空 commandType，通过 v-model 传递给 EmergencyTool 恢复未选中状态
            this.commandType = '';
        },

        selectCaseId (caseId) {
            // console.log('selectCaseId', caseId);
            this.activityCase = this.allCeseList.find((item) => item.id === caseId) || {};
            this.handleCaseSelect(caseId);
        },

        // 应急班组。 包含班组基础信息、成员列表、无人机列表、挂载列表、车两列表。
        async getTeamList () {
            // await api.getTeamList({}).then((res) => {
            //     if (res.code === 200) {
            //         console.log('getTeamList', res);
            //         this.userList = res.data || [];
            //     } else {
            //         this.$message.error(res.msg);
            //     }
            // });
            await api.getTeamUser({}).then((res) => {
                if (res.code === 200) {
                    console.log('getTeamUser', res);
                    this.userList = res.data || [];
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 获取地面摄像头列表
        async getCameraList () {
            await api.getCamera({}).then((res) => {
                if (res.code === 0 || res.code === 200) {
                    console.log('getCamera', res);
                    this.cameraList = res.data || [];
                } else {
                    this.$message.error(res.msg || this.$t('yingji.index.fetchCameraListFailed'));
                }
            });
        },
        async handleCaseSelect (id) {
            this.videoList = [];
            if (!id) return;
            this.isHistoryVideo = true;
            await api.getResourceLive({ caseId: id }).then((res) => {
                if (res.code === 200) {
                    this.videoList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        async handleHistoryVideoClick () {
            if (!this.activityCase.id) {
                this.$message.warning(this.$t('home.middle.video.selectEmergencyCase'));
                return;
            }
            this.isHistoryVideo = false;
            await api.getResourceVideoList({ caseId: this.activityCase.id }).then((res) => {
                if (res.code === 200) {
                    this.videoList = res.data || [];
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        async handleLiveVideoClick () {
            if (!this.activityCase.id) {
                this.$message.warning(this.$t('home.middle.video.selectEmergencyCase'));
                return;
            }
            this.handleCaseSelect(this.activityCase.id);
        },

        // 处理开始日期变化
        handleUpdateStartDate (val) {
            this.startDate = val;
            this.getCaseList();
        },

        // 处理结束日期变化
        handleUpdateEndDate (val) {
            this.endDate = val;
            this.getCaseList();
        },

        // 获取今日应急案件列表
        async getCaseList () {
            const params = {};
            const currentId = this.activityCase && this.activityCase.id ? this.activityCase.id : null;
            if (this.startDate && this.endDate) {
                params.startDate = this.startDate;
                params.endDate = this.endDate;
                params.status = '0,1,2';
            }
            await api.getTodayList(params).then((res) => {
                if (res.code === 200) {
                    this.allCeseList = res.data;
                    if (currentId) {
                        const exist = this.allCeseList.find((item) => item.id === currentId);
                        if (exist) {
                            this.activityCase = exist;
                        } else if (this.allCeseList.length > 0) {
                            this.activityCase = this.allCeseList[0] || {};
                        } else {
                            this.activityCase = {};
                        }
                    } else if (this.allCeseList.length > 0) {
                        this.activityCase = this.allCeseList[0] || {};
                    } else {
                        this.activityCase = {};
                    }
                    this.activityCase.id && this.handleCaseSelect(this.activityCase.id);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        async getCaseCanvasList (caselist) {
            this.caseCanvasList = [];
            let arr = [];
            const promises = caselist.map((item) =>
                // 为每个请求绑定caseId，方便后续匹配结果
                api.getCaseCanvas({ caseId: item.id })
                    .then((res) => ({ ...res })) // 把caseId挂载到返回结果上
                    .catch((err) => ({
                        code: -1,
                        msg: this.$t('yingji.index.requestAbnormal', { msg: err.message || this.$t('yingji.index.requestAbnormal') }),
                        caseId: item.caseId,
                    })), // 单个请求失败不影响整体，返回统一格式的错误结果
            );

            // 4. 等待所有请求完成（无论成功/失败）
            const results = await Promise.all(promises);

            // 5. 处理请求结果
            results.forEach((res) => {
                if (res.code === 200) {
                    let list = res.data;
                    if (list.length > 0) {
                        list.forEach((item) => {
                            if (item.geometryType === 'Point') {
                                arr.push({ ...item, geometry: UtilS.WKTtoParsePoint(item.geometry) });
                            } else if (item.geometryType === 'LineString') {
                                arr.push({ ...item, geometry: UtilS.WKTtoParseLineString(item.geometry) });
                            } else {
                                arr.push({ ...item, geometry: UtilS.WKTtoParsePolygon(item.geometry) });
                            }
                        });
                    }
                } else {
                    // 单个请求失败仅提示，不中断整体流程
                    this.$message.error(this.$t('yingji.index.fetchCaseCanvasFailed', { caseId: res.caseId, msg: res.msg }));
                }
            });
            this.caseCanvasList = arr;
            // console.log('所有案件画布数据请求完成', this.caseCanvasList);
        },

        /**
         * 右侧面板展开收起事件，展开时resize一下统计图表
         */
        handleToggleRight (visible) {
            this.rightShow = visible;
            if (visible) {
                setTimeout(() => {
                    this.$refs.rightRef && this.$refs.rightRef.resizeChart();
                }, 200);
            }
        },

        toggleVideoPanel () {
            this.isVideoCollapsed = !this.isVideoCollapsed;
        },

        handleDangerObjUpdate (newVal) {
            this.dangerObj = newVal;
        },

        startTimer () {
            if (this.timerId) {
                clearInterval(this.timerId);
                this.timerId = null;
            }
            this.timerId = setInterval(() => {
                this.getCaseList();
                if (this.activityCase.id) {
                    this.getCaseCanvasList(this.allCeseList);
                    if (this.isHistoryVideo) {
                        this.handleCaseSelect(this.activityCase.id);
                    }
                }
            }, 30000);
        },

        stopTimer () {
            if (this.timerId) {
                clearInterval(this.timerId);
                this.timerId = null;
            }
        },
        async getPanoramaLocationList() {
            let { data } = await apiPanorama.getPanoramaLocationList();
            this.panoramalocationList = data;
        },

    },
    mounted () {
        this.getCaseList();
        this.getTeamList();
        this.getCameraList();
        this.getPanoramaLocationList();
        if (!this.dangerObj) {
            this.startTimer();
        }
    },
    beforeDestroy () {
        if (this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
    },
    provide () {
        return {
            selectTime: this.selectTime, // 可传递响应式数据
            searchForm: this.searchForm, // 可传递响应式数据
        };
    },
};
</script>

<style lang="scss" scoped>
.main-layout {
    height: calc(100% - 16px);
    padding: 0px 8px;

    .c-middle {
        width: 100%;
        height: 100%;

        .map-container {
            position: relative;

        }

        .legend-position {
            position: absolute;
            bottom: 10px;
            left: 16px;
        }
    }
}

.video-map-row {
    display: flex;
    width: 100%;

    .video-col {
        flex: 0 0 50%;
        height: 100%;
        position: relative;
        transition: flex 0.4s ease, opacity 0.4s ease, visibility 0.4s ease, width 0.4s ease;

        &.collapsed {
            flex: 0 0 0%;
            width: 0;
            opacity: 0;
            visibility: hidden;
            padding: 0;
            margin: 0;
        }

        .video-panel-container {
            height: 100%;
            overflow: hidden;
            padding-right: 10px;
        }
    }

    .map-col {
        flex: 0 0 50%;
        height: 100%;
        position: relative;
        transition: flex 0.4s ease;

        &.expanded {
            flex: 0 0 100%;
        }
    }

    .video-collapse-toggle {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        margin-left: -12px;
        z-index: 10;

        background: transparent;

        .arrow-img {
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
    }
}

.map-container {
    position: relative;

    .legend-position {
        position: absolute;
        bottom: 20px;
        left: 16px;
    }
}

.video-grids__header-live,
.video-grids__header-history {
    display: inline-block;
    height: 30px;
    width: 80px;
    text-align: center;
    padding: 4px 8px;
    margin-left: 8px;
    font-size: 12px;
    line-height: 18px;
    color: #ffffff;
    border: 1px solid #1a47a4;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
        color: rgba(255, 255, 255, 0.9);
        background: #5bf0fc50;
    }

    &.activeVideo {
        color: #fff;
        background: #1a47a4;
    }
}
</style>
